import React from "react";
import Layout from "../Componants/Layout";
import Modal from "react-bootstrap/Modal";
import { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useMutation, useQuery } from "@tanstack/react-query";
import { getRequest, putRequest } from "../services/apiMethods";
import {
  decisionOptions,
  needOptions,
  reponceCount,
} from "../utils/commanFiles";
import DisplayStar from "../Componants/DisplayStar";
import Accordion from 'react-bootstrap/Accordion';
import { isMobile, isTablet } from "react-device-detect";
import { capitalizeWords, filterTheArray } from "../utils/HelperFunctions";
import ConfirmModal from "../Modal/ConfirmModal";
import { Form } from "react-bootstrap";
import toast from "react-hot-toast";
import GiveReviewModal from "../Modal/GiveReviewModal";

export default function CustomerEnquiriesDetail() {
  const param = useParams();
  const [show, setShow] = useState(false);
  const [displayLocal, setDisplayLocal] = useState(true);
  const [isModalOpen, setModalOpen] = useState(false);
  const [selectedType, setSelectedType] = useState("");
  const Navigate = useNavigate();
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const [review, setReview] = useState(false)
  const [checkStatus, setCheckStatus] = useState("")
  const [leadID, setLeadID] = useState("")

  const handleReviewClose = () => {
    setReview(false)
    setLeadID("")
  }
  const handleReviewOpen = () => {
    setReview(true)
  }

  const {
    data: CustomerEnquiriesDetailData,
    error,
    isLoading,
    refetch,
  } = useQuery({
    queryKey: ["CustomerEnquiriesDetail"],
    queryFn: () => getRequest(`/lead/info?id=${param?.id}`),
    enabled: !!param?.id,
  });

  const enquiryDetail = CustomerEnquiriesDetailData?.data;



  const handleDelete = (type) => {
    setModalOpen(true);
    setSelectedType(type);
  };

  const handleConfirmClose = async () => {
    setModalOpen(false);
  };





  const { mutate: updateEnquiriesStatus } = useMutation({
    mutationFn: (data) => {
      return putRequest("/lead/status", data);
    },
    onSuccess: (data) => {
      if (checkStatus == "Work Complete") {
        handleReviewOpen()
      } else {
        toast.success(`${data?.message}`, {
          iconTheme: {
            primary: '#337FE0',
            secondary: '#FFFAEE',
          },
        })
        refetch()
      }
      setCheckStatus("")
    },
    onError: (error) => {
      console.error("Error during API call:", error);
      setCheckStatus("")
    },
  });


  const handleUpdateStatus = (id, status) => {
    if (status == "Work Complete") {
      setCheckStatus(status)
      setLeadID(id)
    }
    const payload = {
      leadId: id,
      status: status
    };
    updateEnquiriesStatus(payload);
  }





  return (
    <>
      <Layout>
        <div className="commn-dubble-siden comm-ver-costomer ">
          <div className="comnn-card-side">
            <div className="customer-card-title ">
              <div>
                <h2
                  className="with-back-btn cursor-pointer"
                  onClick={() => Navigate(-1)}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                  >
                    <path
                      d="M4 12L3.29289 11.2929L2.58579 12L3.29289 12.7071L4 12ZM19 13C19.5523 13 20 12.5523 20 12C20 11.4477 19.5523 11 19 11V13ZM9.29289 5.29289L3.29289 11.2929L4.70711 12.7071L10.7071 6.70711L9.29289 5.29289ZM3.29289 12.7071L9.29289 18.7071L10.7071 17.2929L4.70711 11.2929L3.29289 12.7071ZM4 13H19V11H4V13Z"
                      fill="white"
                    />
                  </svg>
                  All Enquiries
                </h2>
              </div>

              {isMobile || isTablet ?
                <div className="enquiry-details-sidebar">
                  <Accordion>
                    <Accordion.Item eventKey="0">
                      <Accordion.Header>Enquiry Details</Accordion.Header>
                      <Accordion.Body>
                        <div className="enquiry-details-sidebar">

                          <div className="mb-4">
                            <h4>Enquiry Status</h4>
                            <Form.Select aria-label="Default select example" className="update-enquiry-status-drop"

                              value={enquiryDetail?.status}
                              onChange={(e) => handleUpdateStatus(enquiryDetail?._id, e.target.value)}

                            >
                              <option value="Enquired">Enquired</option>
                              <option value="Work Complete">Work Complete</option>
                              <option value="Didn’t hire anyone">Didn’t hire anyone</option>
                            </Form.Select>
                          </div>

                          <div class="detail-para-txt">
                            <p>Looking For</p>
                            <p>{enquiryDetail?.service?.serviceName}</p>
                          </div>
                          <div class="detail-para-txt">
                            <p>Service Category</p>
                            <p>{enquiryDetail?.category?.categoryName}</p>
                          </div>
                          <div class="detail-para-txt">
                            <p>Location</p>
                            <p>
                              {enquiryDetail?.city
                                ? enquiryDetail?.city
                                : enquiryDetail?.address}
                            </p>
                          </div>

                          <div class="detail-para-txt">
                            <p>Personal Project or Business?</p>
                            <p>{enquiryDetail?.businessType}</p>
                          </div>

                          {enquiryDetail?.estimatedBudget && (
                            <div class="detail-para-txt ">
                              <p>Estimated budget</p>
                              <p>£{enquiryDetail?.estimatedBudget}</p>
                            </div>
                          )}

                          <div class="detail-para-txt ">
                            <p>Have you had any quotes before?</p>
                            <p>{enquiryDetail?.quotation}</p>
                          </div>
                          {/* <div class="detail-para-txt ">
                            <p>Start Date</p>
                            <p>{enquiryDetail?.needType}</p>
                          </div> */}

                          <div className="detail-para-txt">
                            <p>Do you have an estimated start date?</p>
                            {needOptions
                              .filter((e) => e.value == enquiryDetail?.needType)
                              .map((ele, idx) => {
                                return <p key={idx}>{ele?.value}</p>;
                              })}
                          </div>
                          <div className="detail-para-txt">
                            <p>How likely are you to make a decision?</p>
                            {decisionOptions
                              .filter((e) => e.value == enquiryDetail?.decisionType)
                              .map((ele, idx) => {
                                return <p key={idx}>{ele?.label}</p>;
                              })}
                          </div>

                          <div class="detail-para-txt mb-5">
                            <p>A brief description of your requirements</p>
                            <p>{enquiryDetail?.taskDescription}</p>
                          </div>

                          <div className="delete-enquiry" onClick={() => handleDelete("deleteCustomerEnquiry")}>
                            <button>
                              Delete Enquiry
                            </button>
                          </div>
                        </div>
                      </Accordion.Body>
                    </Accordion.Item>

                  </Accordion>
                </div>
                :
                <div className="enquiry-details-sidebar">
                  <div className="mb-4">
                    <h3>Enquiry Status</h3>
                    <Form.Select aria-label="Default select example" className="update-enquiry-status-drop"

                      value={enquiryDetail?.status}
                      onChange={(e) => handleUpdateStatus(enquiryDetail?._id, e.target.value)}
                      disabled={enquiryDetail?.status === "Work Complete"}
                    >
                      <option value="Enquired">Enquired</option>
                      <option value="Work Complete">Work Complete</option>
                      <option value="Didn’t hire anyone">Didn’t hire anyone</option>
                    </Form.Select>
                  </div>

                  <div className="enquiry-delete  justify-content-between ">
                    <h3>Enquiry Details</h3>
                  </div>
                  <div class="detail-para-txt">
                    <p>Looking For</p>
                    <p>{enquiryDetail?.service?.serviceName}</p>
                  </div>

                  <div class="detail-para-txt">
                    <p>Service Category</p>
                    <p>{enquiryDetail?.category?.categoryName}</p>
                  </div>

                  <div class="detail-para-txt">
                    <p>Location</p>
                    <p>
                      {enquiryDetail?.city
                        ? enquiryDetail?.city
                        : enquiryDetail?.address}
                    </p>
                  </div>

                  <div class="detail-para-txt">
                    <p>Is it for a Home or a Business?</p>
                    <p>{enquiryDetail?.businessType}</p>
                  </div>

                  {enquiryDetail?.propertyType &&
                    <div class="detail-para-txt">
                      <p>What type of property is it?</p>
                      <p>{enquiryDetail?.propertyType}</p>
                    </div>

                  }


                  <div class="detail-para-txt ">
                    <p>Have you had any quotes before?</p>
                    <p>{enquiryDetail?.quotation}</p>
                  </div>

                  {enquiryDetail?.estimatedBudget && (
                    <div class="detail-para-txt ">
                      <p>Do you have an estimated budget?</p>
                      <p>£{enquiryDetail?.estimatedBudget}</p>
                    </div>
                  )}


                  {/* <div class="detail-para-txt ">
                    <p>Start Date</p>
                    <p>{enquiryDetail?.needType}</p>
                  </div> */}

                  <div className="detail-para-txt">
                    <p>Do you have an estimated start date?</p>
                    {needOptions
                      .filter((e) => e.value == enquiryDetail?.needType)
                      .map((ele, idx) => {
                        return <p key={idx}>{ele?.value}</p>;
                      })}
                  </div>
                  <div className="detail-para-txt">
                    <p>How likely are you to make a decision?</p>
                    {decisionOptions
                      .filter((e) => e.value == enquiryDetail?.decisionType)
                      .map((ele, idx) => {
                        return <p key={idx}>{ele?.label}</p>;
                      })}
                  </div>

                  <div class="detail-para-txt mb-5">
                    <p>A brief description of your requirements</p>
                    <p>{enquiryDetail?.taskDescription}</p>
                  </div>


                  <div className="delete-enquiry" onClick={() => handleDelete("deleteCustomerEnquiry")}>
                    <button>
                      Delete Enquiry
                    </button>
                  </div>
                </div>}
            </div>
          </div>
          <div className="comnn-layout-side">
            <div className="comnn-layout-main">

              {Array.isArray(enquiryDetail?.vendors) &&
                enquiryDetail?.vendors.length > 0 &&
                <>

                  <div className="local-trusted-details mt-5">
                    <div>
                      <h3>Your Responses</h3>
                      <div className="your-responses-step">
                        <h3>
                          {Array.isArray(enquiryDetail?.vendors) &&
                            enquiryDetail?.vendors.length > 0
                            ? enquiryDetail?.vendors.length
                            : "0"}{" "}
                          /5
                        </h3>
                        <ul>
                          {Array.isArray(enquiryDetail?.vendors) &&
                            enquiryDetail?.vendors.length > 0
                            ? enquiryDetail?.vendors
                              .concat(reponceCount)
                              .slice(0, 5)
                              .map((ele, index) => {
                                return (
                                  <li
                                    className={`${ele?.bussinessName ? "active" : ""
                                      } `}
                                    key={index}
                                  ></li>
                                );
                              })
                            : reponceCount.map((ele, index) => {
                              return (
                                <li
                                  className={`${ele?.bussinessName ? "active" : ""
                                    } `}
                                  key={index}
                                ></li>
                              );
                            })}
                        </ul>
                      </div>
                    </div>
                  </div>


                  <div className="trusted-businesses-cards">
                    {Array.isArray(enquiryDetail?.vendors) &&
                      enquiryDetail?.vendors.length > 0 ? (
                      <>
                        <ul>
                          {enquiryDetail?.vendors.map((ele, index) => {
                            return (
                              <li key={index}>
                                <div className="businesses-cards">
                                  <div>
                                    <div className={ele?.subscription?.plan == "Premium" ? "businesses-img" : "withoutPrime-businesses-img"}>
                                      {ele?.image ? (
                                        <img
                                          src={ele?.image}
                                          className={
                                            ele?.subscription?.plan == "Premium"
                                              ? "prime"
                                              : ""
                                          }
                                        />
                                      ) : (
                                        <div
                                          className={
                                            ele?.subscription?.plan == "Premium"
                                              ? "enquiryDetail-custom-circle prime"
                                              : "enquiryDetail-custom-circle "
                                          }
                                        >
                                          <span>
                                            {ele?.bussinessName
                                              ? ele?.bussinessName
                                                ?.toUpperCase()
                                                ?.at(0)
                                              : "N"}
                                          </span>
                                        </div>
                                      )}
                                      {ele?.verificationStatus == "Approved" && (
                                        <span>
                                          <span>
                                            <svg
                                              xmlns="http://www.w3.org/2000/svg"
                                              width="27"
                                              height="27"
                                              viewBox="0 0 27 27"
                                              fill="none"
                                            >
                                              <rect
                                                width="25"
                                                height="25"
                                                rx="12.5"
                                                transform="matrix(-1 0 0 1 26 1)"
                                                fill="#337FE0"
                                                stroke="white"
                                                stroke-width="2"
                                              />
                                              <path
                                                d="M20.0001 10L11.7066 16.8581L8 13.2486"
                                                stroke="white"
                                                stroke-width="2"
                                                stroke-linecap="round"
                                                stroke-linejoin="round"
                                              />
                                            </svg>
                                          </span>
                                        </span>
                                      )}

                                      {ele?.subscription?.plan == "Premium" && (
                                        <span className="prime-icon">
                                          <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="27"
                                            height="27"
                                            viewBox="0 0 27 27"
                                            fill="none"
                                          >
                                            <rect
                                              width="25"
                                              height="25"
                                              rx="12.5"
                                              transform="matrix(-1 0 0 1 26 1)"
                                              fill="#FFC130"
                                              stroke="white"
                                              stroke-width="2"
                                            />
                                            <path
                                              d="M19.9998 12.42L18.7698 17.855C18.7454 17.9687 18.6821 18.0704 18.5908 18.1425C18.4996 18.2146 18.386 18.2526 18.2698 18.25H8.68976C8.57349 18.2526 8.45995 18.2146 8.36869 18.1425C8.27743 18.0704 8.21416 17.9687 8.18976 17.855L6.99976 12.42C6.97974 12.3282 6.986 12.2325 7.01784 12.1441C7.04968 12.0557 7.1058 11.978 7.17976 11.92C7.25393 11.8618 7.34305 11.8257 7.43683 11.816C7.5306 11.8063 7.62522 11.8233 7.70976 11.865L10.6298 13.28L13.0498 9C13.0934 8.92305 13.1566 8.85904 13.233 8.81451C13.3095 8.76998 13.3963 8.74652 13.4848 8.74652C13.5732 8.74652 13.6601 8.76998 13.7365 8.81451C13.8129 8.85904 13.8762 8.92305 13.9198 9L16.3398 13.285L19.2798 11.86C19.3649 11.8149 19.4613 11.7953 19.5573 11.8036C19.6533 11.812 19.7448 11.8479 19.8209 11.9071C19.897 11.9663 19.9543 12.0461 19.9861 12.1371C20.0178 12.2281 20.0225 12.3264 19.9998 12.42Z"
                                              fill="white"
                                            />
                                          </svg>
                                        </span>
                                      )}
                                    </div>
                                    <div className="view-your-resp">
                                      {ele?.bussinessName && <h3>{capitalizeWords(ele?.bussinessName)}</h3>}
                                      {ele?.city ||
                                        `${filterTheArray(
                                          ele?.address
                                        )}, ${ele?.postCode?.slice(0, 3)}`}
                                      <span style={{ display: "flex" }}>
                                        <DisplayStar
                                          rating={
                                            ele?.rating
                                              ? Math.floor(ele?.rating)
                                              : 0
                                          }
                                          size={22}
                                        />
                                        {/* <span className="mt-2">
                                          ({ele?.review} reviews)
                                        </span> */}

                                        {ele?.review == 0 ?
                                          <span className="mt-2" >(0 reviews)</span> :
                                          <span className="mt-2" >({`${ele.review} ${ele.review == 1 ? 'review' : 'reviews'}`})</span>
                                        }
                                      </span>
                                    </div>
                                  </div>
                                  <button
                                    className="theme-comm-btn"
                                    onClick={() =>
                                      Navigate(
                                        `/electrician-profile?vendorId=${ele?._id}`
                                      )
                                    }
                                  >
                                    View Profile
                                  </button>
                                </div>
                              </li>
                            );
                          })}
                        </ul>
                      </>
                    ) : (
                      <p className="empity-responses">
                        Responses from SparkPro members will show here.
                        <br /> We’ll notify you when someone responds to your enquiry.
                      </p>
                    )}
                  </div>
                </>}
              {Array.isArray(enquiryDetail?.premiumvendors) &&
                enquiryDetail?.premiumvendors.length > 0 &&
                <>
                  {displayLocal ? (
                    <>
                      <div className="local-trusted-details">
                        <div>
                          <h3>Local Trusted Businesses </h3>
                          <div
                            className="trusted-hide-btn"
                            onClick={() => setDisplayLocal(!displayLocal)}
                          >
                            Hide{" "}
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="32"
                              height="32"
                              viewBox="0 0 32 32"
                              fill="none"
                            >
                              <rect
                                width="30"
                                height="30"
                                rx="15"
                                transform="matrix(-1 0 0 1 31 1)"
                                stroke="#337FE0"
                                stroke-width="2"
                              />
                              <path
                                d="M11.6055 11.3125L16.293 16L11.6055 20.6875"
                                stroke="#337FE0"
                                stroke-width="2"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              />
                              <path
                                d="M20.6875 11.3125L16 16L20.6875 20.6875"
                                stroke="#337FE0"
                                stroke-width="2"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              />
                            </svg>
                          </div>
                        </div>
                      </div>

                      <div className="trusted-businesses-cards">
                        {Array.isArray(enquiryDetail?.premiumvendors) &&
                          enquiryDetail?.premiumvendors.length > 0 ? (
                          <>
                            <ul>
                              {enquiryDetail?.premiumvendors.map((ele, index) => {
                                return (
                                  <li key={index}>
                                    <div className="businesses-cards">
                                      <div>
                                        <div className={ele?.subscription?.plan == "Premium" ? "businesses-img" : "withoutPrime-businesses-img"}>
                                          {ele?.image ? (
                                            <img
                                              src={ele?.image}
                                              className="prime "
                                            />
                                          ) : (
                                            <div class=" enquiryDetail-custom-circle prime">
                                              <span>
                                                {ele?.bussinessName
                                                  ? ele?.bussinessName
                                                    ?.toUpperCase()
                                                    ?.at(0)
                                                  : "N"}
                                              </span>
                                            </div>
                                          )}
                                          {ele?.verificationStatus ==
                                            "Approved" && (
                                              <span>
                                                <svg
                                                  xmlns="http://www.w3.org/2000/svg"
                                                  width="27"
                                                  height="27"
                                                  viewBox="0 0 27 27"
                                                  fill="none"
                                                >
                                                  <rect
                                                    width="25"
                                                    height="25"
                                                    rx="12.5"
                                                    transform="matrix(-1 0 0 1 26 1)"
                                                    fill="#337FE0"
                                                    stroke="white"
                                                    stroke-width="2"
                                                  />
                                                  <path
                                                    d="M20.0001 10L11.7066 16.8581L8 13.2486"
                                                    stroke="white"
                                                    stroke-width="2"
                                                    stroke-linecap="round"
                                                    stroke-linejoin="round"
                                                  />
                                                </svg>
                                              </span>
                                            )}
                                          {ele?.subscription?.plan == "Premium" && (
                                            <span className="prime-icon">
                                              <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                width="27"
                                                height="27"
                                                viewBox="0 0 27 27"
                                                fill="none"
                                              >
                                                <rect
                                                  width="25"
                                                  height="25"
                                                  rx="12.5"
                                                  transform="matrix(-1 0 0 1 26 1)"
                                                  fill="#FFC130"
                                                  stroke="white"
                                                  stroke-width="2"
                                                />
                                                <path
                                                  d="M19.9998 12.42L18.7698 17.855C18.7454 17.9687 18.6821 18.0704 18.5908 18.1425C18.4996 18.2146 18.386 18.2526 18.2698 18.25H8.68976C8.57349 18.2526 8.45995 18.2146 8.36869 18.1425C8.27743 18.0704 8.21416 17.9687 8.18976 17.855L6.99976 12.42C6.97974 12.3282 6.986 12.2325 7.01784 12.1441C7.04968 12.0557 7.1058 11.978 7.17976 11.92C7.25393 11.8618 7.34305 11.8257 7.43683 11.816C7.5306 11.8063 7.62522 11.8233 7.70976 11.865L10.6298 13.28L13.0498 9C13.0934 8.92305 13.1566 8.85904 13.233 8.81451C13.3095 8.76998 13.3963 8.74652 13.4848 8.74652C13.5732 8.74652 13.6601 8.76998 13.7365 8.81451C13.8129 8.85904 13.8762 8.92305 13.9198 9L16.3398 13.285L19.2798 11.86C19.3649 11.8149 19.4613 11.7953 19.5573 11.8036C19.6533 11.812 19.7448 11.8479 19.8209 11.9071C19.897 11.9663 19.9543 12.0461 19.9861 12.1371C20.0178 12.2281 20.0225 12.3264 19.9998 12.42Z"
                                                  fill="white"
                                                />
                                              </svg>
                                            </span>
                                          )}
                                        </div>
                                        <div>
                                          {ele?.bussinessName && <h3>{capitalizeWords(ele?.bussinessName)}</h3>}
                                          {ele?.city ||
                                            `${filterTheArray(
                                              ele?.address
                                            )}, ${ele?.postCode?.slice(0, 3)}`}
                                          <span style={{ display: "flex" }}>
                                            <DisplayStar
                                              rating={Math.floor(ele?.rating)}
                                              size={22}
                                            />
                                            {/* <span className="mt-2">
                                              ({ele?.review} reviews)
                                            </span> */}

                                            {ele?.review == 0 ?
                                              <span className="mt-2" >(0 reviews)</span> :
                                              <span className="mt-2" >({`${ele.review} ${ele.review == 1 ? 'review' : 'reviews'}`})</span>
                                            }
                                          </span>
                                        </div>
                                      </div>
                                      <button
                                        className="theme-comm-btn"
                                        onClick={() =>
                                          Navigate(
                                            `/electrician-profile?vendorId=${ele?._id}`
                                          )
                                        }
                                      >
                                        View Profile
                                      </button>
                                    </div>
                                  </li>
                                );
                              })}
                            </ul>
                          </>
                        ) : (
                          <p className="empity-responses">
                            Responses from SparkPro members will show here.
                            <br /> We’ll notify you when someone responds to your enquiry.
                          </p>
                        )}
                      </div>
                    </>
                  ) : (
                    <div className="local-trusted-details">
                      <div>
                        <h3> </h3>
                        <button
                          className="theme-comm-btn"
                          onClick={() => setDisplayLocal(!displayLocal)}
                        >
                          View Local Trusted Businesses
                        </button>
                      </div>
                    </div>
                  )}
                </>
              }


              {Array.isArray(enquiryDetail?.vendors) &&
                enquiryDetail?.vendors.length == 0 &&
                <>

                  <div className="local-trusted-details mt-5">
                    <div>
                      <h3>Your Responses</h3>
                      <div className="your-responses-step">
                        <h3>
                          {Array.isArray(enquiryDetail?.vendors) &&
                            enquiryDetail?.vendors.length > 0
                            ? enquiryDetail?.vendors.length
                            : "0"}{" "}
                          /5
                        </h3>
                        <ul>
                          {Array.isArray(enquiryDetail?.vendors) &&
                            enquiryDetail?.vendors.length > 0
                            ? enquiryDetail?.vendors
                              .concat(reponceCount)
                              .slice(0, 5)
                              .map((ele, index) => {
                                return (
                                  <li
                                    className={`${ele?.bussinessName ? "active" : ""
                                      } `}
                                    key={index}
                                  ></li>
                                );
                              })
                            : reponceCount.map((ele, index) => {
                              return (
                                <li
                                  className={`${ele?.bussinessName ? "active" : ""
                                    } `}
                                  key={index}
                                ></li>
                              );
                            })}
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div className="trusted-businesses-cards">

                    <p className="empity-responses">
                      We've sent your enquiry to the electricians closely matching your requirements.
                      <br /> Come back soon to see the results
                    </p>

                  </div>
                </>
              }


            </div>
          </div>
        </div>
        <Modal size="lg" show={show} onHide={handleClose}>
          <Modal.Body>
            <div>
              <div className="account-created-pop">
                <h3 className="justify-content-between">
                  Enquiry Sent!
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="34"
                    height="34"
                    viewBox="0 0 34 34"
                    fill="none"
                  >
                    <rect
                      width="30"
                      height="30"
                      rx="15"
                      transform="matrix(-1 0 0 1 32 2)"
                      stroke="#337FE0"
                      stroke-width="3"
                    />
                    <path
                      d="M23.5625 13.516L14.4916 21.2188L10.4375 17.1647"
                      stroke="#337FE0"
                      stroke-width="3"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </h3>
                <p className="text-start">
                  We’ve successfully sent your enquiry to all SparkPro
                  Electricians in your area.You’ll receive up to 5 responses
                  from companies available to take your project.In the meantime,
                  why don’t you can check out some of the trusted SparkPro
                  members in your area!
                </p>
              </div>
            </div>
          </Modal.Body>
        </Modal>

        <ConfirmModal
          data={param?.id}
          isModalOpen={isModalOpen}
          selectedType={selectedType}
          handleConfirmClose={handleConfirmClose}
        />

        <GiveReviewModal
          review={review}
          handleReviewClose={handleReviewClose}
          leadID={leadID}
        />
      </Layout>
    </>
  );
}
